/**
 * DealerBrandLogo — Jul-2026 (User-Wunsch): In ALLEN Kunden-/Handy-Portalen
 * (Unterschrift, Belege-Upload, Leasing, Termin, Rechnung/Mahnung, Einwilligung,
 * Gelangensbestätigung, mobile Auftragserfassung) wird das Logo des JEWEILIGEN
 * HÄNDLERS gezeigt — niemals das TwoWheels-Logo. Der Kunde kennt TwoWheels nicht,
 * er muss erkennen, von welchem Händler die Nachricht/das Dokument stammt.
 *
 * Fallback (kein Logo hinterlegt): Firmenname als Text-Marke.
 * `variant`: "light" (dunkle Schrift auf hellem Grund) | "dark" (weiße Schrift).
 */
export default function DealerBrandLogo({
    logoUrl,
    companyName,
    variant = "light",
    className = "",
    imgClassName = "h-9 max-w-[180px]",
    textClassName = "text-xl",
}) {
    const name = (companyName || "").trim();
    const url = (logoUrl || "").trim();

    if (url) {
        return (
            <img
                src={url}
                alt={name || "Händler"}
                title={name || undefined}
                className={`object-contain ${imgClassName} ${className}`}
                data-testid="dealer-brand-logo"
            />
        );
    }

    const color = variant === "dark" ? "text-white" : variant === "plain" ? "" : "text-[#111827]";
    return (
        <span
            className={`font-display font-black tracking-tight leading-none ${textClassName} ${color} ${className}`}
            data-testid="dealer-brand-logo"
        >
            {name || "Händler"}
        </span>
    );
}
